import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _protocal;

/*
 * @Author: RYL
 * @Description: 封装数据对象
 * @Date: 2020-11-30 09:50:35
 * @LastEditTime: 2022-03-31 16:40:29
 */
import i18n from "@/common/lang"; // 工作模式

export var workModel = {
  'TCP Server': i18n.t('lang.smartlink.TCPServer'),
  'TCP Client': i18n.t('lang.smartlink.TCPClient'),
  'UDP Server': i18n.t('lang.smartlink.UDPServer'),
  'UDP Client': i18n.t('lang.smartlink.UDPClient'),
  'RealCom': i18n.t('lang.smartlink.RealCom'),
  'MQTT Client': i18n.t('lang.smartlink.MQTTClient'),
  'UART': i18n.t('lang.smartlink.UART'),
  'Modbus TCP Master': i18n.t('lang.smartlink.modbusTCPMain'),
  'Modbus TCP Slave': i18n.t('lang.smartlink.modbusTCPFollow'),
  'Modbus RTU Master': i18n.t('lang.smartlink.modbusRTUMain'),
  'Modbus RTU Slave': i18n.t('lang.smartlink.modbusRTUFollow'),
  'Modbus ASCII Master': i18n.t('lang.smartlink.ModbusASCIIMaster'),
  'Modbus ASCII Slave': i18n.t('lang.smartlink.ModbusASCIIslave'),
  'Local Server': i18n.t('lang.smartlink.localServer'),
  'AIOT': i18n.t('lang.smartlink.AIOT'),
  'UDS Server': i18n.t('lang.smartlink.UDSServer'),
  'S7 Client': i18n.t('lang.smartlink.s7Client')
}; // 工作模式数组

export var workModelOptions = [{
  label: i18n.t('lang.smartlink.TCPServer'),
  value: 'TCP Server'
}, {
  label: i18n.t('lang.smartlink.TCPClient'),
  value: 'TCP Client'
}, {
  label: i18n.t('lang.smartlink.UDPServer'),
  value: 'UDP Server'
}, {
  label: i18n.t('lang.smartlink.UDPClient'),
  value: 'UDP Client'
}, {
  label: i18n.t('lang.smartlink.RealCom'),
  value: 'RealCom'
}, {
  label: i18n.t('lang.smartlink.MQTTClient'),
  value: 'MQTT Client'
}, {
  label: i18n.t('lang.smartlink.UART'),
  value: 'UART'
}, {
  label: i18n.t('lang.smartlink.s7Client'),
  value: 'S7 Client'
}]; // 校验

export var CRCType = [{
  label: 'NULL',
  value: 'NULL'
}, {
  label: 'CRC8',
  value: 'CRC8'
}, {
  label: 'CRC16/ARC',
  value: 'CRC16/ARC'
}, {
  label: 'CRC16/BUYPASS',
  value: 'CRC16/BUYPASS'
}, {
  label: 'CRC16/CCITT-FALSE',
  value: 'CRC16/CCITT-FALSE'
}, {
  label: 'CRC16/GENIBUS',
  value: 'CRC16/GENIBUS'
}, {
  label: 'CRC16/KERMIT',
  value: 'CRC16/KERMIT'
}, {
  label: 'CRC16/X25',
  value: 'CRC16/X25'
}, {
  label: 'CRC16/XMODEM',
  value: 'CRC16/XMODEM'
}]; // 协议

export var protocal = (_protocal = {
  'Pass-Through': i18n.t('lang.smartlink.PassThrough'),
  'Modbus JSON': i18n.t('lang.smartlink.ModbusJSON'),
  'Modbus RTU': i18n.t('lang.smartlink.ModbusRTU'),
  '4G DTU': i18n.t('lang.smartlink.FourGDTU'),
  // 广东质安
  'SCTC OEM': i18n.t('lang.smartlink.SCTCOEM'),
  // 广东质安	
  'Custom Proto': i18n.t('lang.smartlink.Custom'),
  'Custom': i18n.t('lang.smartlink.Custom'),
  'CYKJ OEM': i18n.t('lang.smartlink.CYKJOEM'),
  // 超友科技
  'SHIERYE OEM': i18n.t('lang.smartlink.SHIERYEOEM'),
  // 中国二十冶集团有限公司	
  'EHB OEM': i18n.t('lang.smartlink.EHBOEM')
}, _defineProperty(_protocal, "Modbus RTU", 'Modbus RTU'), _defineProperty(_protocal, 'Modbus TCP', 'Modbus TCP'), _defineProperty(_protocal, 'Modbus IOT', 'Modbus IOT'), _defineProperty(_protocal, 'ChilinkIOT', "ChilinkIOT"), _defineProperty(_protocal, 'IO Control', "IO Control"), _defineProperty(_protocal, 'DAQ', '数据采集'), _defineProperty(_protocal, 'BlockChain', '区块链'), _defineProperty(_protocal, 'UTEPO', 'UTEPO'), _defineProperty(_protocal, 'Modbus ASCII', 'Modbus ASCII'), _defineProperty(_protocal, 'S7', 'S7'), _protocal);
export var protocolMap = {
  'Modbus TCP Master': function ModbusTCPMaster() {
    this.connForm.rsp_timeout = '1500';
    this.connForm.byte_timeout = '60';
    this.protocal = {
      'Modbus TCP': 'Modbus TCP'
    }; // 初始化从站地址

    if (this.lists.slave_addr.length <= 0) {
      this.lists.slave_addr.push('');
    }
  },
  'Modbus RTU Master': function ModbusRTUMaster() {
    this.connForm.rsp_timeout = '1500';
    this.protocal = {
      'Modbus RTU': 'Modbus RTU'
    };
  },
  'Modbus TCP Slave': function ModbusTCPSlave() {
    this.connForm.slave_port = '30001';
    this.protocal = {
      'Modbus TCP': 'Modbus TCP'
    };
  },
  'Modbus RTU Slave': function ModbusRTUSlave() {
    this.connForm.byte_timeout = '60';
    this.protocal = {
      'Modbus RTU': 'Modbus RTU'
    };
  }
};